import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useAuth } from '../store/auth-context';
import Message from '../components/Message';
import { login } from '../api/auth';
import { useNavigate } from 'react-router-dom';

const schema = yup.object().shape({
  password: yup.string().required(),
  email: yup.string().email().required(),
});

const LoginScreen = () => {
  let navigate = useNavigate();

  // const userLogin = useSelector((state) => state.userLogin);
  // const { error, userInfo } = userLogin;
  const { authenticate, isAuthenticated } = useAuth();
  const [error, setError] = useState(false);

  const redirect = '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(redirect);
    }
  }, [error, isAuthenticated, navigate]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  async function LoginHandler(data) {
    setIsSubmitting(true)
    if (!data.password || !data.email) {
      setError('يرجى ادخال البريد الالكتروني و كلمة المرور');
    } else {
      try {
        console.log("LoginHandler")
        const response = await login(data.email, data.password);
        console.log(response)
        if (response?.success) {
          authenticate(response?.token);
          localStorage.setItem('jwt', response?.token);
          navigate("/");
        } else if (response?.success === false) {
          setError(response?.error);
        } else {
          setError(response);
        }
      } catch (error) {
        setError(error);
      }
    }
    setIsSubmitting(false)
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    LoginHandler(data);
  };

  return (
    <div
      className='md:h-screen h-screen w-full sm:pt-0 pt-20 bg-cool-200 '
      dir='rtl'
    >
      <div className=' flex flex-col md:py-28 py-18 container md:px-16 px-3 max-w-3xl'>
        {error && <Message className='pb-8'>{error}</Message>}
        <form action='' className='space-y-6' onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label htmlFor='' className='text-sm font-bold text-gray-600 block'>
              <i className='fas fa-user-shield'></i>
              <span className='px-1'>البريد الالكتروني</span>
            </label>
            <input
              name='email'
              {...register('email')}
              type='email'
              className='w-full p-2 border border-gray-300 rounded mt-1'
            />
            <p className=' opacity-50 text-s'>{errors?.email?.message}</p>
          </div>
          <div>
            <label htmlFor='' className='text-sm font-bold text-gray-600 block'>
              <i className='fas fa-user-lock'></i>
              <span className='px-1'>كلمة السر</span>
            </label>
            <input
              name='password'
              {...register('password')}
              type='password'
              className='w-full p-2 border border-gray-300 rounded mt-1'
            />
            <p className=' opacity-50 text-s'>{errors?.password?.message}</p>
          </div>
          <div className=' '>
            <button
              type='submit'
              disabled={isSubmitting}
              className='w-full bg-button-100 hover:bg-button-100 text-white font-medium px-4 py-2 rounded shadow-md '
            >
              {isSubmitting ?

                <div class="flex items-center justify-center">
                  <div class="animate-spin rounded-full h-6 w-6 border-2 border-dashed border-white"></div>
                </div>

                : "تسجيل دخول"}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
};

export default LoginScreen;
